import { render, staticRenderFns } from "./AllDelegationsList.vue?vue&type=template&id=2bc5d1e9&"
import script from "./AllDelegationsList.vue?vue&type=script&lang=js&"
export * from "./AllDelegationsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports